export const isChunkLoadingError = error => {
	const chunkRegexp = /ChunkLoadError/gi
	const moduleRegexp =
		// eslint-disable-next-line max-len
		/(Importing a module script failed)|(Failed to fetch dynamically imported module)|(Unable to preload CSS for \/assets)/i

	return import.meta.env.PROD && !!error && (chunkRegexp.test(error.message) || moduleRegexp.test(error.message))
}
